import { CommandButton, IContextualMenuProps, Stack } from '@fluentui/react';
import * as React from 'react';


interface IEmailExport {
    firstname: string;
    lastname: string;
    email: string;
}

interface IEmailAddressExportPanelProps {
    emails: IEmailExport[];
}


export const EmailAddressExportPanel: React.FunctionComponent<IEmailAddressExportPanelProps> = (props) => {

    const menuProps: IContextualMenuProps = {
        items: [
            {
                key: 'emailClip',
                text: 'Do schránky',
                iconProps: { iconName: 'Copy' },
                onClick: () => {
                    navigator.clipboard.writeText(props.emails.map(e =>e.email).join(';')).then(function () {
                        console.log('Async: Copying to clipboard was successful!');
                    }, function (err) {
                        console.error('Async: Could not copy text: ', err);
                    });
                }
            },
            {
                key: 'emailcsv',
                text: 'Uložit jako .csv',
                iconProps: { iconName: 'DownloadDocument' },
                onClick: () => {

                    var universalBOM = "\uFEFF";
                    let csvContent = "data:text/csv;charset=utf-8," + universalBOM
                        + props.emails.map(e => e.firstname + ";" + e.lastname + ";" + e.email).join("\n");
                    var encodedUri = encodeURI(csvContent);
                    window.open(encodedUri);

                }

            },
        ],
        // By default, the menu will be focused when it opens. Uncomment the next line to prevent this.
        // shouldFocusOnMount: false
    };


    return (<Stack>
        <CommandButton disabled={props.emails.length===0} menuProps={menuProps} iconProps={{ iconName: "Save" }} text="Ulož email adresy" />

    </Stack>)
}
